export default {
		apiKey: "AIzaSyD4FlrwA5BDtJlrmOY4hdkgI0u9vTicAz4",
		authDomain: "bannerboy-unit-list.firebaseapp.com",
		databaseURL: "https://bannerboy-unit-list.firebaseio.com",
		projectId: "bannerboy-unit-list",
		storageBucket: "bannerboy-unit-list.appspot.com",
		messagingSenderId: "173324594357"
};